// apolo/src/lib/loop/batchBuffer.js — harness-live-verify E1-WS1-T04.
// @arch:pure-engine
//
// Num lote MULTI-CALL, mensagens de usuário interleavadas entre os tool results
// (imageMessage do vision, nudge de missing-args, nudge de reparo de ambiente)
// quebram o run consecutivo de role:'tool' — e no wire NATIVO Anthropic (E1) isso
// derruba o pareamento tool_use/tool_result (fallback pro text-fold, perdendo o
// ganho). Este buffer adia essas mensagens até DEPOIS do último tool_result do
// lote. PURO: a flag (apolo_native_anthropic_tools, default-OFF) é lida pelo
// CALLER (agentLoop) e injetada em `enabled` — core loop/ não importa flags.
// enabled=false — ou lote de 1 call — ⇒ push imediato, ordem byte-idêntica à de hoje.

/**
 * @param {{ batchSize:number, push:(msg:object)=>void, enabled?:boolean }} p
 *   `push` — o sink real (convo_push no spine). `enabled` — a flag, injetada.
 * @returns {{ add:(msg:object)=>void, flush:()=>void }}
 */
export function createBatchBuffer({ batchSize, push, enabled = false }) {
  const defer = !!enabled && batchSize > 1;
  const buf = [];
  return {
    add(msg) {
      if (defer) buf.push(msg);
      else push(msg);
    },
    flush() {
      for (const m of buf) push(m);
      buf.length = 0;
    },
  };
}
